import { render } from "./ExtraSelected.modal.vue?vue&type=template&id=e88ad934"
import script from "./ExtraSelected.modal.vue?vue&type=script&lang=js"
export * from "./ExtraSelected.modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});qInstall(script, 'directives', {ClosePopup});
